import React from 'react'
import {formatDateTime} from '../../../utils/dayJs/format'
import {IPersonResponse} from '../../../coreGlobal/models/person'

interface IListBillings {
  person: IPersonResponse | undefined
}

const ListBillings = ({person}: IListBillings) => (
  <>
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Informações da Cobrança</h3>
        </div>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            <tbody>
              {person?.bank?.map((bank, index) => (
                <React.Fragment key={`listBillingsPersonBank${index}`}>
                  <tr>
                    <td>
                      Tipo: <b>{bank?.main ? 'Principal' : 'Secundário'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Banco: <b>{bank?.bank?.code + ' - ' + bank?.bank?.name || ' '}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Agência:{' '}
                      <b>{bank?.agency + (bank?.agencyDv ? ` - ${bank?.agencyDv}` : '')}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Conta: <b>{bank?.account + ' - ' + bank?.accountDv || ' '}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Chave PIX: <b>{bank?.pixKey || ' '}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Criado em: <b>{formatDateTime(bank?.createdAt)}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Atualizado em: <b>{formatDateTime(bank?.updatedAt)}</b>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </>
)

export {ListBillings}
